export const keyboardKeyEvents = {
	ENTER_KEY_CODE: 13,
	DOWN_ARROW_KEY_CODE: 40,
	UP_ARROW_KEY_CODE: 38,
	ESCAPE_KEY_CODE: 27,
	TAB_KEY_CODE: 9,
	END_KEY_CODE: 35,
	HOME_KEY_CODE: 36
};
export const fileConfigSettings = {
	FILE_MAX_LINES: 1000,
	FILE_ALLOWED_TYPES: ['csv'],
	FILE_MAX_LINES_PER_CHUNK: 10
};

export const studentsSources = {
	UMS: 'UMS',
	FINANCE_PARK: 'FinancePark'
};

export const profileCreationSteps = {
	AVATAR: 'avatar',
	PRE_TEST: 'pretest',
	INTERESTS: 'interests',
	CLUSTER: 'cluster',
	CAREER: 'career',
	EDUCATION: 'education',
	KNOWLEDGE: 'knowledge',
	POST_TEST: 'posttest'
};

export const answersType = {
	MULTI_SELECT: 'Multi Select',
	MULTIPLE_OPTIONS: 'Multiple options',
	TEXT_ONLY: 'Text Only',
	TRUE_OR_FALSE: 'True / False'
};

export const lifestyleQuestionTypes = {
	KNOWLEDGE: 3,
	PREPOST: 4
};

export const COOKIE_HEADER = 'x-cookieexpiresutc';
export const COOKIE_STORAGE_KEY = 'ceUTC';

export const dashboardTutorialSteps = [
	{
		textKey: 'dashboardOnboardingIntro'
	},
	{
		selector: 'savings',
		textKey: 'calendarОnboardingSavings',
		position: 'right'
	},
	{
		selector: 'expenses',
		textKey: 'calendarОnboardingExpCat',
		position: 'top'
	},
	{
		selector: 'profile',
		textKey: 'dashboardOnboardingProfile',
		position: 'right'
	}
];

export const lockGameStages = {
	ALLOCATE_SAVINGS: 'allocateSavings',
	LIFE_SCENARIO: 'lifeScenario',
	LIFE_STAGE_SUMMARY: 'lifeStageSummary',
	AFTER_SET_BUDGET: 'afterSetBudget',
	BUDGETING: 'budgeting',
	SHOPPING: 'shopping',
	AFTER_CALCULATE_NMI: 'afterCalculateNMIPasscode',
	AFTER_LIFE_STAGE_INTRO: 'afterLifeStageIntroPasscode'
};

export const applicationLoanTypes = {
	AUTO_LOAN: 'autoLoan',
	AUTO_LOAN_BANKING_AND_FINANCE: 'autoLoanBankingAndFinance',
	AUTO_LOAN_DEALERSHIP: 'autoLoanDealership',
	MORTGAGE_LOAN: 'mortgageLoan'
};

export const loansDefaultNames = {
	AUTO_LOAN_BANKING_AND_FINANCE: 'Auto Loan - Financial Institution',
	AUTO_LOAN_DEALERSHIP: 'Auto Loan - Dealership Financing',
	MORTGAGE_LOAN: 'Mortgage Loan'
};

export const maritalStatus = {
	MARRIED: 'Married',
	SINGLE: 'Single'
};

export const debtTypes = {
	CREDIT_CARD: 'CreditCard',
	EDUCATION: 'Tuition',
	AUTO_LOAN: 'AutoLoan',
	AUTO_LOAN_DEALERSHIP: 'AutoLoanDealershipFinancing',
	MORTGAGE_LOAN: 'MortgageLoan'
};

export const debtNames = {
	CREDIT_CARD: 'creditCard',
	EDUCATION: 'postSecondaryLoans',
	AUTO_LOAN: 'autoLoanBankingAndFinance',
	AUTO_LOAN_DEALERSHIP: 'autoLoanDealership',
	MORTGAGE_LOAN: 'mortgageLoan'
};

// this is the category's assetName property
// It is used as a unique identifier
export const loanApplicableCategories = {
	TRANSPORTATION: 'transportation',
	HOUSING: 'housing'
};

export const lifeStageOrders = {
	TEENAGER: 0,
	YOUNG_ADULT: 1,
	WORKING_ADULT: 2,
	ADULT_RETIREMENT: 3
};

export const userRoleIds = {
	SUPER_ADMIN: 1,
	USA_ADMIN: 2,
	JA_AREA_ADMIN: 3,
	JA_STAFF: 4,
	EDUCATOR: 5,
	VOLUNTEER: 6,
	STUDENT: 7
};

export const numberPercentage = {
	ZERO: 0,
	TWENTY: 20,
	TWENTY_FIVE: 25,
	FIFTY: 50,
	HUNDRED: 100
};

export const simulationNameType = {
	ADVANCED_VIRTUAL: 'AdvancedVirtual',
	ENTRY_VIRTUAL: 'EntryVirtual',
	ADVANCED_ONSITE: 'AdvancedOnsite',
	ENTRY_ONSITE: 'EntryOnsite'
};

export const simulationTypeArray = [
	{ id: 0, name: 'Advanced Virtual' },
	{ id: 1, name: 'Advanced Onsite' },
	{ id: 2, name: 'Entry Virtual' },
	{ id: 3, name: 'Entry Onsite' }
];

export const studentEnrollment = [
	{ id: 0, name: 'select One', value: '' },
	{ id: 1, name: '3000 and under', value: '' },
	{ id: 2, name: '3000 to 7000', value: '' },
	{ id: 3, name: '7000 to 10000', value: '' },
	{ id: 4, name: '10001 and more', value: '' }
];
export const marketSize = [
	{ id: 0, name: 'select One', value: '' },
	{ id: 1, name: 'Small', value: '' },
	{ id: 2, name: 'Medium', value: '' },
	{ id: 3, name: 'Large', value: '' }
];
export const implementationType = [
	{ id: 0, name: 'select One', value: '' },
	{ id: 1, name: 'Mobile', value: '' },
	{ id: 2, name: 'Physical', value: '' }
];

export const userRoleType = [
	{
		role_ID: 1,
		role_Name: 'JA Super Admin',
		name: 'JA Super Admin',
		role_Description: 'Super Admin',
		parent_Role_ID: 0,
		isActive: true
	},
	{
		role_ID: 2,
		role_Name: 'JA USA Admin',
		name: 'JA USA Admin',
		role_Description: 'National Admin',
		parent_Role_ID: 0,
		isActive: true
	},
	{
		role_ID: 3,
		role_Name: 'JA Area Admin',
		name: 'JA Area Admin',
		role_Description: 'Local Admin',
		parent_Role_ID: 0,
		isActive: true
	},
	{
		role_ID: 4,
		role_Name: 'JA Staff',
		name: 'JA Staff',
		role_Description: 'JA Staff',
		parent_Role_ID: 0,
		isActive: true
	}
];
export const ID_NEW_CMS = '00000000-0000-0000-0000-000000000000';

export const cmsTextAreaMaxLength = {
	SCRIPT_FORM_LENGTH: 500,
	RESEARCH_SCRIPTS_FORM: 500,
	SHOPPING_FORM: 500
};

export const choices = [
	{ name: 'Choice Of Account', value: true },
	{ name: 'Choice Of Doing Nothing', value: false },
	{ name: 'No Choice', value: null }
];

export const amountAdded = [
	{ name: 'positive', value: true },
	{ name: 'negative', value: false }
];

export const actions = [
	{ name: 'Addition', value: true },
	{ name: 'Deduction', value: false }
];

export const isActive = [
	{ name: 'yes', value: true },
	{ name: 'no', value: false }
];

export const sponsorNames = [
	{ name: 'National Sponsor' },
	{ name: 'Local Sponsor' }
];

export const printShoppingTemplates = [
	{ name: 'Paperless', value: false, isActive: false },
	{ name: 'Paper-based', value: true, isActive: false }
];

export const lifeStageDropdown = [
	{
		name: 'Teenager',
		displayOrder: 0,
		lifeStage_ID: '2ff720f5-1149-46cb-b4ac-9e2f4d9f5a0a',
		isActive: true
	},
	{
		name: 'Young Adult',
		displayOrder: 1,
		lifeStage_ID: '974a2de9-41dc-4d81-a9ff-94394dc3611f',
		isActive: true
	},
	{
		name: 'Working Adult',
		displayOrder: 2,
		lifeStage_ID: '0728ec87-3dbf-46f8-aa59-0296692ee124',
		isActive: true
	},
	{
		name: 'Adult Nearing Retirement',
		displayOrder: 3,
		lifeStage_ID: 'cea4690a-cb25-4501-8b29-9ed1e5075bed',
		isActive: true
	}
];

export const onsiteSimulationTypes = [
	simulationNameType.ENTRY_ONSITE,
	simulationNameType.ADVANCED_ONSITE
];
export const defaultNames = {
	AUTO_LOAN: 'Auto Loan',
	AUTO_LOAN_DEALERSHIP: 'Auto Loan - Dealership Financing',
	CHECKING_ACCOUNT: 'Checking Account',
	MORTGAGE_LOAN: 'Mortgage Loan',
	TRANSPORTATION: 'Transportation',
	HOUSING: 'Housing',
	SAVINGS: 'savings',
	BUDGET: 'budget',
	CREDIT: 'credit',
	CHECKING: 'checking',
	CREDIT_CARD: 'Credit Card',
	POST_SECONDARY_LOAN: 'Post-Secondary Education Loan',
	GENERAL_SAVINGS: 'General Savings',
	NAME_GENERAL_SAVINGS: 'generalSavings'
};

export const environmentType = {
	DEV: 'development',
	PROD: 'production'
};

export const cloudDomainSuffixes = [
	'jafinanceparkapi.ja.org',
	'jafpwebapistaging.ja.org',
	'jafpwebapitest.ja.org',
	'api.jafinancepark.ie',
	'testapi.jafinancepark.ie'
];
